import { render } from "./CompanyiasPage.vue?vue&type=template&id=cfee6aba"
import script from "./CompanyiasPage.vue?vue&type=script&lang=js"
export * from "./CompanyiasPage.vue?vue&type=script&lang=js"

import "./CompanyiasPage.vue?vue&type=style&index=0&id=cfee6aba&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__